import { render, staticRenderFns } from "./PlatformOrder.vue?vue&type=template&id=f4c164aa&scoped=true"
import script from "./PlatformOrder.vue?vue&type=script&lang=js"
export * from "./PlatformOrder.vue?vue&type=script&lang=js"
import style0 from "./PlatformOrder.vue?vue&type=style&index=0&id=f4c164aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c164aa",
  null
  
)

export default component.exports